import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { BRAND, waOrder } from "../../data/zingly";

export const OrderModal = ({ item, onClose }) => {
  return (
    <AnimatePresence>
      {item && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          onClick={onClose}
          data-testid="order-modal-backdrop"
        >
          <motion.div
            initial={{ scale: 0.7, opacity: 0, rotateX: 25 }}
            animate={{ scale: 1, opacity: 1, rotateX: 0 }}
            exit={{ scale: 0.85, opacity: 0, rotateX: -10 }}
            transition={{ type: "spring", stiffness: 220, damping: 22 }}
            style={{ transformStyle: "preserve-3d", perspective: "1200px" }}
            className="relative bg-white rounded-[2rem] max-w-lg w-full overflow-hidden shadow-[0_40px_80px_-20px_rgba(0,0,0,0.4)] border border-orange-100"
            onClick={(e) => e.stopPropagation()}
            data-testid="order-modal"
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/90 backdrop-blur shadow-md flex items-center justify-center hover:bg-white"
              aria-label="Close"
              data-testid="order-modal-close"
            >
              <X className="w-5 h-5 text-[#1E1E1E]" />
            </button>

            <div className="relative h-56 overflow-hidden">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-4 left-6 right-6">
                <h3 className="font-serif text-3xl font-extrabold text-white">{item.title}</h3>
                <div className="mt-1 text-white/90 font-semibold">₹{item.price}</div>
              </div>
            </div>

            <div className="p-7">
              <p className="text-[#555555] text-sm leading-relaxed">{item.longDescription}</p>

              <div className="mt-5 rounded-2xl bg-[#FFF8F1] border border-orange-100 p-4">
                <div className="text-xs uppercase tracking-wider text-[#F58220] font-semibold mb-2">
                  How to order
                </div>
                <p className="text-sm text-[#555555]">
                  Tap WhatsApp below — we&apos;ll receive your message with the item pre-filled.
                  We&apos;ll confirm availability & share delivery time right away.
                </p>
              </div>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                <a
                  href={waOrder(item.title)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="modal-whatsapp-btn"
                  className="btn-3d inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-gradient-to-r from-[#25D366] to-[#1ebd5b] text-white font-semibold text-sm"
                >
                  <FaWhatsapp className="w-5 h-5" /> Order on WhatsApp
                </a>
                <a
                  href={`tel:${BRAND.phoneRaw}`}
                  data-testid="modal-call-btn"
                  className="btn-3d-outline inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-white text-[#F58220] font-semibold text-sm border-2 border-[#F58220]"
                >
                  <Phone className="w-4 h-4" /> Call Us
                </a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
